<template>
    <kv-card
        v-if="answer"
        class="linked-answer-panel"
        collapsible
        v-model="isOpen"
        density="compact"
    >
        <template #title>
            <div class="linked-answer-title" @click.stop="isOpen = !isOpen">
                <kv-typography weight="medium" color="secondary" size="medium">
                    {{ panelTitle }}
                </kv-typography>
            </div>
        </template>
        <template #text>
            <answer-list :answers="answer.answers || []" />
            <div class="linked-answer-actions" v-if="showInboxLink && answer.id">
                <router-link class="open-answer-link" :to="inboxRoute">
                    {{ t("tasks-open_answer") }}
                    <Icon icon-class="ui-chevron-right" size="2" />
                </router-link>
            </div>
        </template>
    </kv-card>
</template>

<script>
import KvCard from "../ui/kv-card.vue";
import KvTypography from "../ui/kv-typography.vue";
import Icon from "../icon/icon";
import AnswerList from "./answer-list.vue";

export default {
    name: "LinkedAnswerPanel",
    components: {
        KvCard,
        KvTypography,
        Icon,
        AnswerList,
    },
    props: {
        answer: {
            type: Object,
            default: null,
        },
        defaultOpen: {
            type: Boolean,
            default: true,
        },
        showInboxLink: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            isOpen: this.defaultOpen,
        };
    },
    computed: {
        panelTitle() {
            if (this.title) {
                return this.title;
            }
            return (
                (this.answer && this.answer.form_name) ||
                this.t("tasks-form_response")
            );
        },
        inboxRoute() {
            const clientsId =
                (this.answer && this.answer.clients_id) || null;
            return {
                path: "/inbox",
                query: {
                    filter: JSON.stringify({
                        client: clientsId,
                    }),
                    message_id: this.answer.id,
                },
            };
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>

<style scoped lang="less">
.linked-answer-title {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    cursor: pointer;
    padding-right: 28px;
}

.linked-answer-actions {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #f3f4f6;
}

.open-answer-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--primary);
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}
</style>
